import React from "react";

export default function Remove({ color = "#fff", ...restProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      id="RemoveIcon"
      x="0px"
      y="0px"
      viewBox="0 0 19 18"
      style={{ enableBackground: "new 0 0 19 18" }}
      xmlSpace="preserve"
      width="19px"
      height="18px"
      {...restProps}
    >
      <g>
        <polygon
          points="9.47792206 7.6234625 17.0506923 0.0506922801 18.4051518 1.40515184 10.8323816 8.97792206 18.4051518 16.5506923 17.0506923 17.9051518 9.47792206 10.3323816 1.90515184 17.9051518 0.55069228 16.5506923 8.1234625 8.97792206 0.55069228 1.40515184 1.90515184 0.0506922801"
          fill={color}
        />
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  );
}
